import { observable, makeObservable } from 'mobx'
import * as R from 'ramda'

class TriggerChild {
    @observable triggers

    getLabel(index) {
        if (!this.store) return ''
        const pageQuestion = this.store.survey.pageQuestions[this.triggers[index].condition.pageQuestionId]
        console.log('getLabel')
        if (!pageQuestion) {
            return 'Orphan logic'
        }
        const optionSet = pageQuestion.question.isDoubleAxis()
            ? pageQuestion.question.optionSetY : pageQuestion.question.optionSet
        const option = optionSet.options.find((option) => {
            return option.id === this.triggers[index].condition.set1
        })
        if (!option) {
            return 'Option removed'
        }
        return option.langs.get('en_GB').text
    }

    constructor(triggerChild, store, survey, triggerGroup) {
        makeObservable(this)
        Object.assign(this, triggerChild)
        this.store = store
        this.triggerGroup = triggerGroup

        this.interTriggerLogicalOperator = triggerChild.length > 0
            ? triggerChild[0].interTriggerLogicalOperator || 'OR'
            : 'OR'
    }

    updateTriggerOperator(operator) {
        this.triggers = this.triggers.map((t) => {
            t.interTriggerLogicalOperator = operator
            return t
        })
        this.interTriggerLogicalOperator = operator
        console.log('updateTriggerOperator', this.triggers)
    }

    updateGroupOperator(operator) {
        this.interGroupLogicalOperator = operator
    }

    getPageQuestionId = () => R.pathOr(null, ['triggers', 0, 'condition', 'pageQuestionId'], this)

    hasQuotaLogic = () => {
        return this.triggers.some(({ condition }) => condition.kind === 'Quota')
    }

    hasDateLogic = (dateField) => (
        this.triggers.some(({ condition }) => (
            condition.kind === 'Date'
            && condition.dateField === dateField
        ))
    )

    addTrigger(setY, pageQuestionId, setX, inheritedPageQuestionId) {
        const trigger = {
            condition: {
                kind: 'QuestionOptionExistsInSurveyResponse',
                pageQuestionId,
                set1: setX ? setX.id : setY.id,
                set2: setX ? setY.id : null,
                equalityOperator: 'Eq',
                inheritedPageQuestionId: inheritedPageQuestionId || null,
            },
        }
        // if (this.triggers.length > 0) {
        trigger.interTriggerLogicalOperator = this.interTriggerLogicalOperator
        // }
        this.triggers.push(trigger)
    }

    addHasResponseTrigger = (pageQuestionId, setY = null) => {
        const trigger = {
            condition: {
                kind: 'QuestionExistsInSurveyResponse',
                pageQuestionId,
                set1: setY,
                responseExists: true,
            },
        }

        trigger.interTriggerLogicalOperator = this.interTriggerLogicalOperator
        this.triggers.push(trigger)
    }

    addNumericTrigger = (pageQuestionId, equalityOperator, value, setY = null) => {
        const trigger = {
            condition: {
                kind: 'QuestionHasNumericResponse',
                pageQuestionId,
                value,
                equalityOperator,
                set1: setY,
            },
        }

        trigger.interTriggerLogicalOperator = this.interTriggerLogicalOperator
        this.triggers.push(trigger)
    }

    addSurveyQuotaTrigger = (pageQuestionId) => {
        const trigger = {
            condition: {
                kind: 'Quota',
                quota: 0,
                equalityOperator: 'Gt',
            },
        }
        // if (this.triggers.length > 0) {
        trigger.interTriggerLogicalOperator = this.interTriggerLogicalOperator
        // }
        this.triggers.push(trigger)
    }

    addSurveyDateTrigger = (dateField) => {
        const trigger = {
            condition: {
                kind: 'Date',
                dateField,
                equalityOperator: 'Gt',
            },
        }
        trigger.interTriggerLogicalOperator = this.interTriggerLogicalOperator
        this.triggers.push(trigger)
    }

    clear() {
        this.triggers = []
        this.triggerGroup.triggerRemoved()
    }

    removeTrigger(index, e) {
        this.triggers.splice(index, 1)
        this.triggerGroup.triggerRemoved()
        e.stopPropagation()
        e.nativeEvent.stopImmediatePropagation()
    }

    toJSON() {
        const json = {
            triggers: this.triggers,
            interGroupLogicalOperator: this.interGroupLogicalOperator,
        }
        return json
    }
}

export default TriggerChild
